module.exports = __webpack_public_path__ + "img/sls3.d49f299b.jpg";